<template>
  <div class="ListView" @click="listClick()">
    <slot></slot>
    <i class="el-icon-arrow-right"></i>
  </div>
</template>

<script>
export default {
  name: 'ListView',
  data() {
    return {
    }
  },
  methods: {
    listClick() {
      this.$emit('listClick')
    }
  }
}
</script>

<style scoped>
.ListView {
  background: var(--white);
  border: 1px solid var(--gray30);
  border-radius: 4px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all .3s linear;
}
.ListView:hover {
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.08);
}
.ListView .list-content {
  width: 100%;
  display: grid;
  gap: 8px;
}
.ListView .list-item {
  font-size: var(--content-font-size);
  line-height: var(--content-line-height);
  display: inline-flex;
  width: 100%;
}
.ListView .list-item .label {
  padding-right: 16px;
  color: var(--gray600);
  flex-shrink: 0;
}

/* ------------ for desktop ------------ */
@media (min-width: 768px) {
  .ListView .list-content {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
